import { UserInfo } from "../../apps/reader/framework/api/features/user/types";
import { hash } from "../utils/string";
import { useLocalStorageValue } from "../ui/useLocalStorageValue";

export enum FractionPersistKey {
  SKIPPED_SSO = "skipSSO",
}

/**
 * Option 1: Stored via "persist" key in local storage
 * @see useFractionStorageValue
 */
export default function useFractionPersistValue<T>(
  userInfo: UserInfo,
  key: FractionPersistKey
): T | undefined {
  const { value } = useLocalStorageValue("persist");

  if (userInfo.email) {
    const userKey = `${hash(userInfo.email)}__${key}`;
    return value[userKey]?.value;
  }
}
